module.exports = __webpack_public_path__ + "images/harleyf4639dff766f6362f66547322f1970e7.png";